module.exports = __webpack_public_path__ + "static/img/2-3-9.f092317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serviceContent/2-3-9.jpg
// module id = vIgA
// module chunks = 1